import moment from 'moment'

// fill this api keys for Playground display WMS requests
const WILDFIRES = 'b21370d0-bae0-4c0a-a4f1-3d587dfc5347'
const FLOODING = 'be9de139-9858-437d-bded-f60a6282b8fb'
const SENTINEL_5 = '309d60bc-4258-47a8-b596-1cd3ed5b7185'
const SENTINEL_3 = '6f4f7260-f07a-46ca-b6fd-ca8ac3ca3800'
const SENTINEL_1 = '86b9d36d-2445-421f-972f-d11e59b4c671'
const SENTINEL_2 = '89510f7b-d278-4cc6-9296-d821178afa57'
const SENTINEL_2_L2_API_KEY = '96fbe0b8-a41d-4f4e-8e92-b79ae279ce45'
const SENTINEL_2_API_KEY = '330cfde7-191c-441a-93bc-e7a08786fce0'
const LANDSAT_8_API_KEY = 'ca5c8dc4-258e-490c-bf64-ff3498057368' //'d1951594-daea-42dc-8d51-203014edc660'
const DEM_API_KEY = '7c9dfe5e-3d02-454b-93cc-a062ccfc0b28'
const MODIS_API_KEY = 'b719a6ad-d135-42df-bf7c-f794b2d99b4c'//'eb44b4ab-f98b-4511-824f-c5068e04a8a3'

const DATASOURCES = [
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L2_API_KEY}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L2_API_KEY}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2017-03-28',
    id: 'DSS2',
    datasourceID: 'S2L2A',
    name: 'Sentinel-2 L2A',
    typeNames: 'DSS2',
    min: 9
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_API_KEY}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_API_KEY}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L1C/searchIndex',
    minDate: '2015-01-01',
    id: 'S2.TILE',
    datasourceID: 'S2L1C',
    name: 'Sentinel-2 L1C',
    typeNames: 'S2.TILE'
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_1}`,
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1',
    name: 'Sentinel-1'
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2015-01-01',
    id: 'S2_A',
    datasourceID: 'S2L2A',
    name: 'Sentinel-2',
    typeNames: 'DSS2'
  },
  {
    url: `https://sh.dataspace.copernicus.eu/ogc/wms/${SENTINEL_3}`,
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S3',
    name: 'Sentinel-3'
  },
  {
    url: `https://sh.dataspace.copernicus.eu/ogc/wms/${SENTINEL_5}`,
    index: 'https://sh.dataspace.copernicus.eu/index/v3/collections/S5PL2/searchIndex',
    minDate: '2020-01-01',
    id: 'S5',
    name: 'Sentinel-5P'
  },
  {
    url: `https://services-uswest2.sentinel-hub.com/v1/wms/${LANDSAT_8_API_KEY}`,
    index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/L8L1C/searchIndex',
    minDate: '2013-01-01',
    id: 'L8',
    datasourceID: 'L8L1C',
    name: 'Landsat 8',
    min: 10,
    typeNames: 'DSS6'
  },
  {
    url: `https://services-uswest2.sentinel-hub.com/v1/wms/${DEM_API_KEY}`,
    index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/DEM/searchIndex',
    minDate: '2013-01-01',
    id: 'DEM',
    name: 'DEM',
    datasourceID: 'DEM',
    min: 2,
    typeNames: 'DSS4'
  },
  {
    url: `https://services-uswest2.sentinel-hub.com/v1/wms/${MODIS_API_KEY}`,
    index: 'https://services-uswest2.sentinel-hub.com/index/modis/v2/',
    minDate: '2013-01-01',
    id: 'Modis',
    noEffects: true,
    name: 'MODIS',
    datasourceID: 'MODIS',
    min: 7,
    typeNames: 'DSS5'
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2017-03-28',
    id: 'FLOODING',
    datasourceID: 'S2L2A',
    name: 'FLOODING',
    typeNames: 'DSS2',
    min: 9
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2017-03-28',
    id: 'WILDFIRES',
    datasourceID: 'S2L2A',
    name: 'WILDFIRES',
    typeNames: 'DSS2',
    min: 9
  }
]
const datasources = DATASOURCES,
  customPreset = {
    CUSTOM: {
      name: 'Custom',
      desc: 'Create custom rendering',
      image: 'image.jpg'
    }
  },
  VIEWS = {
    PRESETS: '1',
    BANDS: '2',
    SCRIPT: '3'
  }

export default {
  noCredentials: SENTINEL_2_API_KEY === '' && LANDSAT_8_API_KEY === '' && MODIS_API_KEY === '',
  customPreset,
  layers: {
    r: 'B04',
    g: 'B03',
    b: 'B02'
  },
  activeDatasource: {...DATASOURCES[0]},
  startLocation: '',
  doRefresh: true,
  activeBaseLayer: {
    name: '',
    minmax: { min: 0, max: 16 }
  },
  evalscripturl: '',
  isLoaded: true,
  lat: 35.29898719945333,
  lng: 24.415740966796875,
  zoom: 9,
  size: [0, 0],
  priority: 'mostRecent',
  mosaic: 'mostRecent',
  evalscript: '',
  renderedEvalscript: '',
  opacity: 100,
  maxcc: 20,
  imgWmsUrl: '',
  mapBounds: {},
  minDate: '2015-01-01',
  maxDate: moment(),
  selectedDate: moment().add(-1,'days'),
  dateFormat: 'YYYY-MM-DD',
  availableDays: [],
  datesCcMap: {},
  onDayPicked: false,
  prevDate: null,
  nextDate: null,
  showDates: false,
  preset: null,
  currView: VIEWS.PRESETS,
  channels: [],
  path: '',
  presets: {
    customPreset
  },
  presetsLegend: [],
  atmFilter: '',
  cloudCorrection: 'none',
  gain: new Number(1).toFixed(1),
  gamma: new Number(1).toFixed(1),
  legendVisible: false,
  devMode: false,
  selectedDevToolsTab: 1,
  devModalVisible: false,
  legendX: 0,
  legendY: 0,
  legendHeight: 0,
  legendWidth: 0,
  legendUrl: null,
  views: VIEWS,
  datasources
}



// WEBPACK FOOTER //
// ./src/store/config.js